module.exports = "/static/Images/pt-br/positive.png";